module.exports = __webpack_public_path__ + "img/twitterLight.7d30fe11.svg";